// @ts-nocheck
export const createRequestQueue = () => {
  let chain = Promise.resolve();

  const enqueue = (task) => {
    chain = chain.then(() => task());
    return chain;
  };

  const reset = () => {
    chain = Promise.resolve();
  };

  return {
    enqueue,
    reset,
  };
};
